import type { History, Model } from '@/pages/projections/engine'
import type { CaseInputs } from '@/pages/projections/engine/types'
import { validateCase } from '@/pages/projections/projectionsValidation'
import type { ModelSummaryResponse } from '@/services/projections'
import {
  thresholdsFromSettings,
  validationOptionsFromModel,
} from '@/store/projectionsStore'

export function uploadValidationIsClean(
  evaluated: Model,
  draft: CaseInputs,
  history: History,
  model: ModelSummaryResponse | null,
): boolean {
  const result = validateCase(
    evaluated,
    draft,
    history,
    thresholdsFromSettings(model),
    validationOptionsFromModel(model, draft.cash_policy),
  )
  return result.errors.length === 0 && result.warnings.length === 0
}
